import styles from './MailListItem.scss';
import { observer } from 'mobx-react-lite';
import { highlightTermsInHtmlElement } from 'owa-highlight';
import * as React from 'react';

export interface MailListItemLineTextProps {
    addOverflowStyles: boolean;
    highlightTerms: string[];
    text: string;
    tooltipText: string;
}

export default observer(function MailListItemLineText(
    props: MailListItemLineTextProps
): JSX.Element {
    const { addOverflowStyles, highlightTerms: _highlightTerms, text, tooltipText } = props;

    const highlightTerms = React.useCallback(
        (element: HTMLElement) => {
            highlightTermsInHtmlElement(
                element,
                _highlightTerms,
                false /* separateWordSearch */,
                true /* matchPrefix */
            );
        },
        [_highlightTerms]
    );

    return (
        <span
            className={addOverflowStyles ? styles.secondLineText : undefined}
            title={tooltipText}
            ref={highlightTerms}>
            {text}
        </span>
    );
});
